/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Table from "components/Table/TableAdmin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Pagination from "react-responsive-pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import CardFooter2 from "components/Card/CardFooter.js";
import TSSelect from "components/Forms/TSSelect";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import { CardFooter } from "reactstrap";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import { Modal, ModalBody } from "reactstrap";
import axios from "utils/httpClient";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function Admin() {
  const classes = useStyles();
  const classes2 = useStyles2();

  const [l1Option, setL1Option] = useState([]);
  const [option1, setOption1] = useState("");
  const [tableHead, setTableHead] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [currentPage3, setCurrentPage3] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPages2, setTotalPages2] = useState(1);
  const [totalPages3, setTotalPages3] = useState(1);
  const [pageSize] = useState(10);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const windowWidth = useWindowWidth();
  const [isEdit, setIsEdit] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit2, setIsEdit2] = useState(false);
  const [isAdd2, setIsAdd2] = useState(false);
  const [isEdit3, setIsEdit3] = useState(false);
  const [isAdd3, setIsAdd3] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isDelete2, setIsDelete2] = useState(false);
  const [isDelete3, setIsDelete3] = useState(false);
  const [group2Id, setGroup2Id] = useState(0);
  const [group3Id, setGroup3Id] = useState(0);
  const [group4Id, setGroup4Id] = useState(0);
  const [name, setName] = useState("");
  const [name2, setName2] = useState("");
  const [name3, setName3] = useState("");
  const [tag, setTag] = useState("");
  const [modal, setModal] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError2, setModalError2] = useState(false);
  const [errMsg2, setErrMsg2] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [modalDelete, setModalDelete] = useState(false);

  var currentUser = JSON.parse(localStorage.getItem('currentUser'))

  useEffect(() => {

    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setL1Option(result.data);
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   );

      axios("/api/v1/group1")
      .then(
        result => {
          var res = result.data;
          setL1Option(res.data);
        }, error => {console.log(error);}
      );  

      //tableHead.push("ชื่อ", "แก้ไข", "ลบ");
      setTableHead(["ชื่อ", "แก้ไข", "ลบ"]);
  }, []);

  useEffect(() => {
    if (group2Id !== 0) {
      axios("/api/v1/group2Id/" + group2Id)
        .then(response => response.data)
        .then(
          result => {
            setName(result.data.groupName);
            setTag(result.data.tags);
            //console.log(result.data);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [isEdit, group2Id]);

  useEffect(() => {
    if (group3Id !== 0) {
      axios("/api/v1/group3Id/" + group3Id)
        .then(response => response.data)
        .then(
          result => {
            setName2(result.data.groupName);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [isEdit2, group3Id]);

  useEffect(() => {
    if (group4Id !== 0) {
      axios("/api/v1/group4Id/" + group4Id)
        .then(response => response.data)
        .then(
          result => {
            setName3(result.data.groupName);
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [isEdit3, group4Id]);

  useEffect(() => {
    if (option1 !== "") {
      setName("");
      setTag("");
      setIsAdd(false);
      setIsDelete(false);
      setIsEdit(false);
      setGroup2Id(0);
      axios(
        "/api/v1/tableAdmin/" +
          option1 +
          "/pagination?PageNumber=" +
          currentPage +
          "&PageSize=" +
          pageSize
      )
        .then(response => response.data)
        .then(
          result => {
            var tableList = [];
            if (result.data.length > 0) {
              result.data.forEach(e => {
                tableList.push([
                  e.groupName,
                  "edit",
                  "delete",
                  e.group1Id,
                  e.group2Id
                ]);
              });
              setData(tableList);
              setIsEdit(false);
              setIsEdit2(false);
              setIsEdit3(false);
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages(1);
              } else {
                setTotalPages(total);
              }
            } else {
              setData([]);
              setCurrentPage(1);
              setTotalPages(1);
            }
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [option1, currentPage]);

  useEffect(() => {
    if (option1 === 1 || option1 === 4) {
      axios(
        "/api/v1/tableAdmin2/" +
          group2Id +
          "/pagination?PageNumber=" +
          currentPage2 +
          "&PageSize=" +
          pageSize
      )
        .then(response => response.data)
        .then(
          result => {
            var tableList = [];
            if (result.data.length > 0) {
              result.data.forEach(e => {
                tableList.push([
                  e.groupName,
                  "edit",
                  "delete",
                  e.group2Id,
                  e.group3Id
                ]);
              });
              setData2(tableList);
              setIsEdit2(false);
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages2((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages2(1);
              } else {
                setTotalPages2(total);
              }
            } else {
              setData2([]);
              setCurrentPage2(1);
              setTotalPages2(1);
            }
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [isEdit, group2Id, currentPage2, option1, pageSize]);

  useEffect(() => {
    if (option1 === 4) {
      axios(
        "/api/v1/tableAdmin3/" +
          group3Id +
          "/pagination?PageNumber=" +
          currentPage3 +
          "&PageSize=" +
          pageSize
      )
        .then(response => response.data)
        .then(
          result => {
            var tableList = [];
            if (result.data.length > 0) {
              result.data.forEach(e => {
                tableList.push([
                  e.groupName,
                  "edit",
                  "delete",
                  e.group3Id,
                  e.group4Id
                ]);
              });
              setData3(tableList);
              setIsEdit3(false);
              var total = result.total / pageSize;
              if (!Number.isInteger(total)) {
                setTotalPages3((total | 0) + 1);
              } else if (total === 0) {
                setTotalPages3(1);
              } else {
                setTotalPages3(total);
              }
            } else {
              setData3([]);
              setCurrentPage3(1);
              setTotalPages3(1);
            }
          },
          error => {
            console.log(error);
          }
        );
    }
  }, [isEdit2, group3Id, currentPage3, option1, pageSize]);

  const onEdit = e => {
    setIsEdit(e);
    setIsAdd(false);
  };

  const onDelete = e => {
    setIsDelete(e);
    setModalDelete(true);
  };

  const onSelected = e => {
    setGroup2Id(e);
  };

  const onEdit2 = e => {
    setIsEdit2(e);
    setIsAdd2(false);
  };

  const onDelete2 = e => {
    setIsDelete2(e);
    setModalDelete(true);
  };

  const onSelected2 = e => {
    setGroup3Id(e);
  };

  const onEdit3 = e => {
    setIsEdit3(e);
    setIsAdd3(false);
  };

  const onDelete3 = e => {
    setIsDelete3(e);
    setModalDelete(true);
  };

  const onSelected3 = e => {
    setGroup4Id(e);
  };

  const setBoth = () => {
    setIsAdd(true);
    setIsEdit(false);
    setIsEdit2(false);
    setIsEdit3(false);
    setGroup2Id(0);
    setGroup3Id(0);
    setGroup4Id(0);
    setName("");
    setTag("");
  };

  const setBoth2 = () => {
    setIsAdd2(true);
    setIsEdit2(false);
    setIsEdit3(false);
    setGroup3Id(0);
    setGroup4Id(0);
    setName2("");
  };

  const setBoth3 = () => {
    setIsAdd3(true);
    setIsEdit3(false);
    setGroup4Id(0);
    setName3("");
  };

  const getTable = () => {
    axios(
      "/api/v1/tableAdmin/" +
        option1 +
        "/pagination?PageNumber=" +
        currentPage +
        "&PageSize=" +
        pageSize
    )
      .then(response => response.data)
      .then(
        result => {
          var tableList = [];
          if (result.data.length > 0) {
            result.data.forEach(e => {
              tableList.push([
                e.groupName,
                "edit",
                "delete",
                e.group1Id,
                e.group2Id
              ]);
            });
            setData(tableList);
            var total = result.total / pageSize;
            if (!Number.isInteger(total)) {
              setTotalPages((total | 0) + 1);
            } else if (total === 0) {
              setTotalPages(1);
            } else {
              setTotalPages(total);
            }
          } else {
            setData([]);
            setCurrentPage(1);
            setTotalPages(1);
          }
        },
        error => {
          console.log(error);
        }
      );
  };

  const getTable2 = () => {
    axios(
      "/api/v1/tableAdmin2/" +
        group2Id +
        "/pagination?PageNumber=" +
        currentPage2 +
        "&PageSize=" +
        pageSize
    )
      .then(response => response.data)
      .then(
        result => {
          var tableList = [];
          if (result.data.length > 0) {
            result.data.forEach(e => {
              tableList.push([
                e.groupName,
                "edit",
                "delete",
                e.group2Id,
                e.group3Id
              ]);
            });
            setData2(tableList);
            setIsEdit2(false);
            var total = result.total / pageSize;
            if (!Number.isInteger(total)) {
              setTotalPages2((total | 0) + 1);
            } else if (total === 0) {
              setTotalPages2(1);
            } else {
              setTotalPages2(total);
            }
          } else {
            setData2([]);
            setCurrentPage2(1);
            setTotalPages2(1);
          }
        },
        error => {
          console.log(error);
        }
      );
  };

  const getTable3 = () => {
    axios(
      "/api/v1/tableAdmin3/" +
        group3Id +
        "/pagination?PageNumber=" +
        currentPage3 +
        "&PageSize=" +
        pageSize
    )
      .then(response => response.data)
      .then(
        result => {
          var tableList = [];
          if (result.data.length > 0) {
            result.data.forEach(e => {
              tableList.push([
                e.groupName,
                "edit",
                "delete",
                e.group3Id,
                e.group4Id
              ]);
            });
            setData3(tableList);
            setIsEdit3(false);
            var total = result.total / pageSize;
            if (!Number.isInteger(total)) {
              setTotalPages3((total | 0) + 1);
            } else if (total === 0) {
              setTotalPages3(1);
            } else {
              setTotalPages3(total);
            }
          } else {
            setData3([]);
            setCurrentPage3(1);
            setTotalPages3(1);
          }
        },
        error => {
          console.log(error);
        }
      );
  };

  function useWindowWidth() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth - 400);

    useEffect(() => {
      const resizeHandler = () => {
        setWindowWidth(window.innerWidth - 400);
      };

      window.addEventListener("resize", resizeHandler);
      return () => {
        window.removeEventListener("resize", resizeHandler);
      };
    }, []);
    return windowWidth;
  }

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if (
      (name === null || name === "") &&
      ((isEdit && !isEdit2 && !isEdit3) || (isAdd && !isAdd2 && !isAdd3))
    ) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อ"}</li>);
    }

    if (
      (name2 === null || name2 === "") &&
      ((isEdit && isEdit2 && !isEdit3) || (!isAdd && isAdd2 && !isAdd3))
    ) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อ"}</li>);
    }

    if (
      (name3 === null || name3 === "") &&
      ((isEdit && isEdit2 && isEdit3) || (!isAdd && !isAdd2 && isAdd3))
    ) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อ"}</li>);
    }

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }
  };

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    if (isAdd) {
      // const requestOptions = {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json-patch+json"
      //   },
      //   body: JSON.stringify({
      //     GroupName: name,
      //     Group1Id: option1,
      //     Tags: tag
      //   })
      // };
   

      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setModal(false);
      //       setIcon("far fa-question-circle");
      //       getTable();
      //       setGroup2Id(result.data.group2Id);
      //       setIsEdit(true);
      //       setIsAdd(false);
      //       setName(result.data.groupName);
      //       setTag(result.data.tags);
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );

        var js = {
          groupName: name,
          group1Id: option1,
          tags: tag,
          creatorCode: currentUser.userName,
          LastediterCode: currentUser.userName
         }
  
        axios.post("/api/v1/data/group2", js)
        .then (
          result => {
          var res = result.data;
            setModal(false);
            setIcon("far fa-question-circle");
            getTable();
            setGroup2Id(res.data.group2Id);
            setIsEdit(true);
            setIsAdd(false);
            setName(res.data.groupName);
            setTag(res.data.tags);
          },
          error => { console.log(error);}
        );
    } else if (isEdit && !isEdit2 && !isEdit3 && !isAdd2 && !isAdd3) {
      var edit = {
        GroupName: name,
        Tags: tag,
        LastediterCode: currentUser.userName
      };


      //   method: "PUT",
      //   headers: { "Content-Type": "application/json-patch+json" },
      //   body: JSON.stringify(edit)
      // })
      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setModal(false);
      //       setIcon("far fa-question-circle");
      //       getTable();
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );

      axios.put("/api/v1/group2/" + group2Id, edit)
      .then (
        result => {
        var res = result.data;
        setModal(false);
        setIcon("far fa-question-circle");
        getTable();
        },
        error => { console.log(error);}
      );
    } else if (isEdit && isEdit2 && !isEdit3 && !isAdd2 && !isAdd3) {
      var edit2 = {
        GroupName: name2,
        LastediterCode: currentUser.userName
      };


      //   method: "PUT",
      //   headers: { "Content-Type": "application/json-patch+json" },
      //   body: JSON.stringify(edit2)
      // })
      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setModal(false);
      //       setIcon("far fa-question-circle");
      //       getTable2();
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );

      axios.put("/api/v1/group3/" + group3Id, edit2)
      .then (
        result => {
        setModal(false);
        setIcon("far fa-question-circle");
        getTable();
        },
        error => { console.log(error);}
      );
    } else if (isAdd2) {
      // const requestOptions = {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json-patch+json"
      //   },
      //   body: JSON.stringify({
      //     GroupName: name2,
      //     Group1Id: option1,
      //     Group2Id: group2Id
      //   })
      // };


      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setModal(false);
      //       setIcon("far fa-question-circle");
      //       getTable2();
      //       setGroup3Id(result.data.group3Id);
      //       setIsEdit2(true);
      //       setIsAdd2(false);
      //       setName2(result.data.groupName);
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );

      var js2 = {
        groupName: name2,
        group1Id: option1,
        group2Id: group2Id,
        creatorCode: currentUser.userName,
        LastediterCode: currentUser.userName
      }
      
      axios.post("/api/v1/data/group3", js2)
      .then (
        result => {
        var res = result.data;
        setModal(false);
        setIcon("far fa-question-circle");
        getTable2();
        setGroup3Id(res.data.group3Id);
        setIsEdit2(true);
        setIsAdd2(false);
        setName2(res.data.groupName);
      },
        error => { console.log(error);}
      );
    } else if (isEdit && isEdit2 && isEdit3 && !isAdd3) {
      // eslint-disable-next-line no-redeclare
      var edit = {
        GroupName: name3,
        LastediterCode: currentUser.userName
      };


      //   method: "PUT",
      //   headers: { "Content-Type": "application/json-patch+json" },
      //   body: JSON.stringify(edit)
      // })
      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setModal(false);
      //       setIcon("far fa-question-circle");
      //       getTable3();
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );

      axios.put("/api/v1/group4/" + group4Id, edit)
      .then (
        result => {
          setModal(false);
          setIcon("far fa-question-circle");
          getTable3();
        },
        error => { console.log(error);}
      );
    } else if (isAdd3) {
      // const requestOptions = {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json-patch+json"
      //   },
      //   body: JSON.stringify({
      //     GroupName: name3,
      //     Group1Id: option1,
      //     Group2Id: group2Id,
      //     Group3Id: group3Id
      //   })
      // };


      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setModal(false);
      //       setIcon("far fa-question-circle");
      //       getTable3();
      //       setGroup4Id(result.data.group4Id);
      //       setIsEdit3(true);
      //       setIsAdd3(false);
      //       setName3(result.data.groupName);
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );

        var js3 = {
          groupName: name3,
          group1Id: option1,
          group2Id: group2Id,
          group3Id: group3Id,
          creatorCode: currentUser.userName,
          LastediterCode: currentUser.userName
        }

        axios.post("/api/v1/data/group4", js3)
        .then (
          result => {
          var res = result.data;
            setModal(false);
            setIcon("far fa-question-circle");
            getTable3();
            setGroup4Id(res.data.group4Id);
            setIsEdit3(true);
            setIsAdd3(false);
            setName3(res.data.groupName);
          },
          error => { console.log(error);}
        );
    }
  };

  const handleDelete = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    if (isDelete) {

      //   method: "DELETE"
      // })
      //   .then(response => response.text())
      //   .then(
      //     result => {
      //       var myBool = String("") === result;
      //       if (!myBool) {
      //         setModalDelete(false);
      //         setIcon("far fa-question-circle");
      //         var errMsg = [];
      //         var cntErr = 0;

      //         cntErr += 1;
      //         errMsg.push(
      //           <li key={cntErr - 1}>
      //             {"กรุณาตรวจสอบตัวชี้วัดที่มีอยู่ก่อนลบ"}
      //           </li>
      //         );

      //         setErrMsg2(errMsg);
      //         setModalError2(true);
      //       } else {
      //         setModalDelete(false);
      //         setIcon("far fa-question-circle");
      //         getTable();
      //         setIsDelete(false);
      //         setIsEdit(false);
      //         setIsAdd(false);
      //       }
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );

        axios.delete("/api/v1/data/group2/" + group2Id)
        .then (
          result => {
          var res = result.data;
            setModalDelete(false);
            setIcon("far fa-question-circle");
            getTable();
            setIsDelete(false);
            setIsEdit(false);
            setIsAdd(false);
          },
          error => { 
            setModalDelete(false);
            setIcon("far fa-question-circle");
            var errMsg = [];
            var cntErr = 0;
  
            cntErr += 1;
            errMsg.push(
            <li key={cntErr - 1}>
              {error.response.data}
            </li>
            );
  
            setErrMsg2(errMsg);
            setModalError2(true);
            console.log(error);
          }
        );
    } else if (isDelete2) {

      //   method: "DELETE"
      // })
      //   .then(response => response.text())
      //   .then(
      //     result => {
      //       var myBool = String("") === result;
      //       if (!myBool) {
      //         setModalDelete(false);
      //         setIcon("far fa-question-circle");
      //         var errMsg = [];
      //         var cntErr = 0;

      //         cntErr += 1;
      //         errMsg.push(
      //           <li key={cntErr - 1}>
      //             {"กรุณาตรวจสอบตัวชี้วัดที่มีอยู่ก่อนลบ"}
      //           </li>
      //         );

      //         setErrMsg2(errMsg);
      //         setModalError2(true);
      //       } else {
      //         setModalDelete(false);
      //         setIcon("far fa-question-circle");
      //         getTable2();
      //         setIsDelete2(false);
      //         setIsEdit2(false);
      //         setIsAdd2(false);
      //       }
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );
      axios.delete("/api/v1/data/group3/" + group3Id)
        .then (
          result => {
          var res = result.data;
          setModalDelete(false);
          setIcon("far fa-question-circle");
          getTable2();
          setIsDelete2(false);
          setIsEdit2(false);
          setIsAdd2(false);
        },
        error => { 
          setModalDelete(false);
          setIcon("far fa-question-circle");
          var errMsg = [];
          var cntErr = 0;
    
          cntErr += 1;
          errMsg.push(
            <li key={cntErr - 1}>
               {error.response.data}
            </li>
          );
    
          setErrMsg2(errMsg);
          setModalError2(true);
          console.log(error);
        }
      );
    } else if (isDelete3) {

      //   method: "DELETE"
      // })
      //   .then(response => response.text())
      //   .then(
      //     result => {
      //       var myBool = String("") === result;
      //       if (!myBool) {
      //         setModalDelete(false);
      //         setIcon("far fa-question-circle");
      //         var errMsg = [];
      //         var cntErr = 0;

      //         cntErr += 1;
      //         errMsg.push(
      //           <li key={cntErr - 1}>
      //             {"กรุณาตรวจสอบตัวชี้วัดที่มีอยู่ก่อนลบ"}
      //           </li>
      //         );

      //         setErrMsg2(errMsg);
      //         setModalError2(true);
      //       } else {
      //         setModalDelete(false);
      //         setIcon("far fa-question-circle");
      //         getTable3();
      //         setIsDelete3(false);
      //         setIsEdit3(false);
      //         setIsAdd3(false);
      //       }
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );
      axios.delete("/api/v1/data/group4/" + group4Id)
        .then (
          result => {
          var res = result.data;
          setModalDelete(false);
          setIcon("far fa-question-circle");
          getTable3();
          setIsDelete3(false);
          setIsEdit3(false);
          setIsAdd3(false);
        },
        error => { 
          setModalDelete(false);
          setIcon("far fa-question-circle");
          var errMsg = [];
          var cntErr = 0;
    
          cntErr += 1;
          errMsg.push(
            <li key={cntErr - 1}>
              {error.response.data}
            </li>
          );
    
          setErrMsg2(errMsg);
          setModalError2(true);
        }
      );
    }
  };



  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Icon>
                  <AssignmentInd />
                </Icon>
              </CardIcon>
              <p className={classes2.cardCategory}>Welcome to</p>
              <h3 className={classes2.cardTitle}>
                ปีงบประมาณ <small>2563</small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={999}
                    options={l1Option}
                    onChange={e => setOption1(e)}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
            </CardBody>
            <CardFooter2 chart></CardFooter2>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info">
              <h4 className={classes.cardTitleWhite}>Simple Table</h4>
              <p className={classes.cardCategoryWhite}>
                Here is a subtitle for this table
              </p>
            </CardHeader>
            <CardBody>
              {option1 !== 0 && option1 !== "" && (
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ textAlign: "center" }}
                  >
                    <Button color="info" type="button" onClick={setBoth}>
                      <h4>เพิ่ม</h4>
                    </Button>
                  </GridItem>
                </GridContainer>
              )}
              <Table
                tableHeaderColor="info"
                tableHead={tableHead}
                tableData={data}
                isEdit={onEdit}
                isDelete={onDelete}
                select={onSelected}
              />
            </CardBody>
            <CardFooter>
              <Pagination
                current={currentPage}
                total={totalPages}
                onPageChange={setCurrentPage}
                maxWidth={windowWidth}
              />
            </CardFooter>
          </Card>
        </GridItem>
        {(isEdit || isAdd) && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info">
                <h4 className={classes.cardTitleWhite}>Simple Table</h4>
                <p className={classes.cardCategoryWhite}>
                  Here is a subtitle for this table
                </p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="ชื่อ"
                      id="name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setName(e)}
                      value={name}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Tags"
                      id="tag"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setTag(e)}
                      value={tag}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
              <GridContainer>
                {/* Confirm */}
                <Modal toggle={() => setModal(false)} isOpen={modal}>
                  <div className="modal-header justify-content-center">
                    <div>
                      <i
                        className={icon}
                        style={{ color: "blue", fontSize: "2em" }}
                      ></i>
                    </div>
                  </div>
                  <ModalBody>
                    <p
                      style={{
                        textAlign: "center"
                      }}
                    >
                      {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        ? "ยืนยันการบันทึกข้อมูล"
                        : "กำลังตรวจสอบข้อมูล"}
                    </p>
                    <p> </p>
                  </ModalBody>
                  <div className="modal-footer">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => setModal(false)}
                    >
                      <h4>ยกเลิก</h4>
                    </Button>

                    <Button
                      color="primary"
                      type="button"
                      onClick={handleConfirm}
                      disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                    >
                      <h4>ยืนยัน</h4>
                    </Button>
                  </div>
                </Modal>

                {/* Error */}
                <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                  <div className="modal-header justify-content-center">
                    <div>
                      <i
                        className="fa fa-times"
                        style={{ color: "red", fontSize: "2em" }}
                      ></i>
                    </div>
                  </div>
                  <ModalBody>
                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                    <div>{errMsg}</div>
                  </ModalBody>
                  <div className="modal-footer justify-content-center">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => setModalError(false)}
                    >
                      <h4>ตกลง</h4>
                    </Button>
                  </div>
                </Modal>
              </GridContainer>
              <CardFooter style={{ textAlign: "center" }}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="info" onClick={handleSubmit}>
                      {isAdd && <h4>บันทึก</h4>}
                      {isEdit && <h4>แก้ไข</h4>}
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardFooter>
            </Card>
          </GridItem>
        )}

        <GridContainer>
          {/* Error */}
          <Modal toggle={() => setModalError2(false)} isOpen={modalError2}>
            <div className="modal-header justify-content-center">
              <div>
                <i
                  className="fa fa-times"
                  style={{ color: "red", fontSize: "2em" }}
                ></i>
              </div>
            </div>
            <ModalBody>
              <p>ไม่สามารถบันทึกข้อมูลได้</p>
              <div>{errMsg2}</div>
            </ModalBody>
            <div className="modal-footer justify-content-center">
              <Button
                color="primary"
                type="button"
                onClick={() => setModalError2(false)}
              >
                <h4>ตกลง</h4>
              </Button>
            </div>
          </Modal>
        </GridContainer>

        {(isDelete || isDelete2 || isDelete3) && (
          <GridContainer>
            <Modal toggle={() => setModalDelete(false)} isOpen={modalDelete}>
              <div className="modal-header justify-content-center">
                <div>
                  <i
                    className={icon}
                    style={{ color: "blue", fontSize: "2em" }}
                  ></i>
                </div>
              </div>
              <ModalBody>
                <p
                  style={{
                    textAlign: "center"
                  }}
                >
                  {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                    ? "ยืนยันการลบข้อมูล"
                    : "กำลังตรวจสอบข้อมูล"}
                </p>
                <p> </p>
              </ModalBody>
              <div className="modal-footer">
                <Button
                  color="primary"
                  type="button"
                  onClick={() => setModalDelete(false)}
                >
                  <h4>ยกเลิก</h4>
                </Button>

                <Button
                  color="primary"
                  type="button"
                  onClick={handleDelete}
                  disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                >
                  <h4>ยืนยัน</h4>
                </Button>
              </div>
            </Modal>
          </GridContainer>
        )}

        {isEdit && !isAdd && (option1 === 1 || option1 === 4) && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose">
                <h4 className={classes.cardTitleWhite}>Simple Table</h4>
                <p className={classes.cardCategoryWhite}>
                  Here is a subtitle for this table
                </p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ textAlign: "center" }}
                  >
                    <Button color="rose" type="button" onClick={setBoth2}>
                      <h4>เพิ่ม</h4>
                    </Button>
                  </GridItem>
                </GridContainer>
                <Table
                  tableHeaderColor="rose"
                  tableHead={tableHead}
                  tableData={data2}
                  isEdit={onEdit2}
                  isDelete={onDelete2}
                  select={onSelected2}
                />
              </CardBody>
              <CardFooter>
                <Pagination
                  current={currentPage2}
                  total={totalPages2}
                  onPageChange={setCurrentPage2}
                  maxWidth={windowWidth}
                />
              </CardFooter>
            </Card>
          </GridItem>
        )}

        {(isEdit2 || isAdd2) && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose">
                <h4 className={classes.cardTitleWhite}>Simple Table</h4>
                <p className={classes.cardCategoryWhite}>
                  Here is a subtitle for this table
                </p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="ชื่อ"
                      id="name2"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setName2(e)}
                      value={name2}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter style={{ textAlign: "center" }}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="rose" onClick={handleSubmit}>
                      {isAdd2 && <h4>บันทึก</h4>}
                      {isEdit2 && <h4>แก้ไข</h4>}
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardFooter>
            </Card>
          </GridItem>
        )}

        {isEdit2 && !isAdd2 && option1 === 4 && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Simple Table</h4>
                <p className={classes.cardCategoryWhite}>
                  Here is a subtitle for this table
                </p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ textAlign: "center" }}
                  >
                    <Button color="success" type="button" onClick={setBoth3}>
                      <h4>เพิ่ม</h4>
                    </Button>
                  </GridItem>
                </GridContainer>
                <Table
                  tableHeaderColor="success"
                  tableHead={tableHead}
                  tableData={data3}
                  isEdit={onEdit3}
                  isDelete={onDelete3}
                  select={onSelected3}
                />
              </CardBody>
              <CardFooter>
                <Pagination
                  current={currentPage3}
                  total={totalPages3}
                  onPageChange={setCurrentPage3}
                  maxWidth={windowWidth}
                />
              </CardFooter>
            </Card>
          </GridItem>
        )}
        {(isEdit3 || isAdd3) && (
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>Simple Table</h4>
                <p className={classes.cardCategoryWhite}>
                  Here is a subtitle for this table
                </p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="ชื่อ"
                      id="name3"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setName3(e)}
                      value={name3}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter style={{ textAlign: "center" }}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <Button color="success" onClick={handleSubmit}>
                      {isAdd3 && <h4>บันทึก</h4>}
                      {isEdit3 && <h4>แก้ไข</h4>}
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardFooter>
            </Card>
          </GridItem>
        )}
      </GridContainer>
    </div>
  );
}
